import moment from 'moment';
import { NEW_WORKFLOW_ID, NODE_STRUCTURE_BY_TYPE, NODE_TYPES } from '../constants';
import { WorkflowType } from '../enums';
import { BackendEdge, BackendNode, BackendWorkflow, Workflow } from '../types';

export const isNewWorkflow = (workflowId: number): boolean =>
  Number(workflowId) === NEW_WORKFLOW_ID;

export type NewNode = BackendNode & { workflowId?: number };

export type NewWorkflowForCreate = Partial<Omit<BackendWorkflow, 'id' | 'goals'>> & {
  id?: Workflow['id'] | null;
  nodes: NewNode[];
  edges: BackendEdge[];
};

const getNewStartNode = (overrides: Record<string, any>): NewNode => {
  const nodeDefaults = NODE_STRUCTURE_BY_TYPE[NODE_TYPES.START];

  return {
    ...nodeDefaults,
    x: 50,
    y: 50,
    id: -1,
    title: 'Start',
    nodeData: {
      ...nodeDefaults.nodeData,
      ...overrides,
    },
  };
};

export const getNewWorkflowData = (
  id?: number,
  workflowType: WorkflowType = WorkflowType.PUBLISHED,
  startNodeOverrides = {},
) => ({
  data: {
    workflow: {
      nodes: [getNewStartNode(startNodeOverrides)],
      description: '',
      edges: [],
      enabled: false,
      id: id || NEW_WORKFLOW_ID,
      name: `Journey created on ${moment().format('ddd, MMM Do YYYY, h:mm:ss a')}`,
      workflowLifetimeLimit: null,
      workflowSimultaneousLimit: null,
      workflowType,
    },
  },
});

export const getNewWorkflowDraftData = (
  id?: number | null,
  startNodeOverrides = {},
): { data: { workflow: NewWorkflowForCreate } } => ({
  data: {
    workflow: {
      nodes: [getNewStartNode(startNodeOverrides)],
      description: '',
      edges: [] as BackendEdge[],
      enabled: false,
      id,
      name: `Journey created on ${moment().format('ddd, MMM Do YYYY, h:mm:ss a')}`,
      workflowLifetimeLimit: null,
      workflowSimultaneousLimit: null,
      workflowType: WorkflowType.DRAFT,
    },
  },
});
